module.exports = __webpack_public_path__ + "chart.b1c8b018bce64147b523.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chart.svg
// module id = ./src/assets/img/chart.svg
// module chunks = main